export default __webpack_public_path__ + "static/hero-3-d920d361750c9d05b7740aea9e154bec.jpg";